import React from 'react';

import InputLabel from '../../widgets/input-label';

import SVGIcon from '../../../../../../../common/react/components/svg-icon';
import Localization from '../../../../../../../common/edlio-js/models/BackendLocalization';

export default class RadioButtonElement extends React.Component {
	render() {
		let localization = new Localization(window.edlio.localizations);
		return (
			<div className='radio input'>
                <SVGIcon name='filled-circle' />
				<InputLabel ref='label' label={localization.localize(this.props.data.label)} placeholder={localization.localize('Option')} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/components/form-elements/inputs/radio-button.js